/**
 * Offline queue for write requests (record ball / edit ball / undo / set bowler).
 * Stores items in localStorage and replays them in order when network is available.
 */
const KEY = "crickpad-offline-queue";
const EVT = "crickpad-queue-change";

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

function write(q) {
  localStorage.setItem(KEY, JSON.stringify(q));
  window.dispatchEvent(new CustomEvent(EVT));
}

export function enqueue(item) {
  const q = read();
  q.push({ ...item, ts: Date.now() });
  write(q);
}

export function pendingCount() {
  return read().length;
}

export function subscribe(cb) {
  const handler = () => cb(pendingCount());
  window.addEventListener(EVT, handler);
  window.addEventListener("online", handler);
  window.addEventListener("offline", handler);
  return () => {
    window.removeEventListener(EVT, handler);
    window.removeEventListener("online", handler);
    window.removeEventListener("offline", handler);
  };
}

export async function drainQueue(client) {
  const q = read();
  if (q.length === 0) return { drained: 0, remaining: 0 };
  let drained = 0;
  while (q.length > 0) {
    const item = q[0];
    try {
      await client.request({ url: item.url, method: item.method, data: item.data });
      q.shift();
      drained += 1;
      // persist intermediate progress
      write(q);
    } catch (e) {
      // Stop replay on first failure (likely still offline or backend error)
      break;
    }
  }
  return { drained, remaining: q.length };
}

export function clearQueue() {
  write([]);
}
